import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { SINGLE_PURCHASE } from '@grandvisionhq/fun-products';
import { formatPrice, mapProductTypeToProductCategory, mapProductStockToProductStatus } from '@grandvisionhq/svc-tealium/utils';
import { isDefined } from '@grandvisionhq/utils';
import { getProductTypeName } from '../../helpers.js';

const mapProductToTealiumProperties = (product, activeVariant)=>{
    var ref;
    const isPublished = product.published && activeVariant.isPublished;
    const prices = (ref = activeVariant.purchaseTypePrices) === null || ref === void 0 ? void 0 : ref[SINGLE_PURCHASE];
    let originalPrice = '';
    let discountedPrice = '';
    if (prices) {
        originalPrice = formatPrice(prices.originalPrice, true);
        discountedPrice = prices.discountedPrice ? formatPrice(prices.discountedPrice, true) : originalPrice;
    }
    const productTypeName = getProductTypeName(product);
    const productProperties = {
        Category: mapProductTypeToProductCategory(productTypeName),
        Price: discountedPrice,
        PriceFull: originalPrice,
        ModelName: activeVariant.modelName
    };
    if (!CommerceToolsApi.isLenses(activeVariant) && !CommerceToolsApi.isContactLensBundle(activeVariant) && isDefined(activeVariant.availability)) {
        var ref1;
        var ref2;
        productProperties.Status = mapProductStockToProductStatus((ref2 = (ref1 = activeVariant.availability) === null || ref1 === void 0 ? void 0 : ref1.availableQuantity) !== null && ref2 !== void 0 ? ref2 : 0, isPublished);
    }
    if (CommerceToolsApi.isProductWithAFrame(activeVariant) || CommerceToolsApi.isLenses(activeVariant)) {
        productProperties.LensType = 'PLANO';
    }
    return productProperties;
};

export { mapProductToTealiumProperties };
//# sourceMappingURL=map-product-to-tealium-properties.js.map
